'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const components_navigation_Button_BaseButton = require('../Button/BaseButton.cjs.js');

const ButtonNavButton = (props) => {
  return react.jsx(components_navigation_Button_BaseButton.BaseButton, Object.assign({}, props, { size: "small" }));
};

exports.ButtonNavButton = ButtonNavButton;
//# sourceMappingURL=ButtonNavButton.cjs.js.map
